// Block Creation Components
/**
 * WordPress dependencies
 */
import {
	BlockControls,
	BlockEdit,
	BlockFormatControls,
	DefaultBlockAppender,
	createCustomColorsHOC,
	getColorClassName,
	getColorObjectByAttributeValues,
	getColorObjectByColorValue,
	InspectorControls,
	PlainText,
	RichText,
	RichTextShortcut,
	RichTextToolbarButton,
	RichTextInserterItem,
	__unstableRichTextInputEvent,
	MediaPlaceholder,
	URLInput,
	withColors,
	withFontSizes,
} from '@wordpress/block-editor';

export {
	BlockControls,
	BlockEdit,
	BlockFormatControls,
	DefaultBlockAppender,
	createCustomColorsHOC,
	getColorClassName,
	getColorObjectByAttributeValues,
	getColorObjectByColorValue,
	InspectorControls,
	PlainText,
	RichText,
	RichTextShortcut,
	RichTextToolbarButton,
	RichTextInserterItem,
	__unstableRichTextInputEvent,
	MediaPlaceholder,
	URLInput,
	withColors,
	withFontSizes,
};
